export default __webpack_public_path__ + "static/media/ceramol-acn3-spot-block-960.9b4888f5.png";